import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/shared/button/Button';
import './NoteEditor.css';
import TextArea from 'components/shared/input/TextArea';
import SimpleTruncate from 'components/shared/text/SimpleTruncate';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import { todayValidation } from 'services/utils/date-util';
import Date from 'components/shared/text/Date';

export default function NoteEditor(props) {
  const handleClick = () => {
    if (props.edit) {
      if (props.onSave) {
        props.onSave();
      }
    } else {
      if (props.onEdit) {
        props.onEdit();
      }
    }
  };

  const handleChange = (value) => {
    if (props.onValueChange) {
      props.onValueChange(value);
    }
  };

  const handleReminderValueChange = (value) => {
    if (props.onReminderValueChange) {
      props.onReminderValueChange(value);
    }
  };

  let buttonLabel;
  if (props.edit) {
    if (props.saving) {
      buttonLabel = 'Saving...';
    } else {
      buttonLabel = 'Save';
    }
  } else {
    buttonLabel = props.editButtonLabel;
  }
  return (
    <div className="note-editor">
      <div className="small-bold ne-label">{props.label}</div>
      <div className="ne-row">
        {props.edit && !props.saving ? (
          <div>
            <TextArea
              readOnly={props.saving}
              value={props.value}
              onChange={handleChange}
            />
            <div className="reminder-container">
              <div className="small-bold ne-label">{props.reminderLabel}</div>
              <DatetimePicker
                placeholder="Reminder Date"
                value={props.reminderValue}
                isValidDate={todayValidation}
                onChange={(value) => handleReminderValueChange(value)}
              />
            </div>
          </div>
        ) : (
          <div>
            <div className="small-regular">
              <SimpleTruncate shownLines={props.lines} text={props.value} />
            </div>
            {props.reminderOriginalValue && (
              <div className="reminder-container">
                <div className="small-bold ne-label">{props.reminderLabel}</div>
                <Date format="LL" value={props.reminderOriginalValue} />
              </div>
            )}
          </div>
        )}
        {props.canEdit && (
          <div>
            <Button
              className="button-orange"
              disabled={props.saving}
              label={buttonLabel}
              onClick={handleClick}
            />
          </div>
        )}
      </div>
    </div>
  );
}

NoteEditor.propTypes = {
  editButtonLabel: PropTypes.string,
  canEdit: PropTypes.bool,
  edit: PropTypes.bool,
  label: PropTypes.string.isRequired,
  lines: PropTypes.number,
  reminderLabel: PropTypes.string,
  reminderOriginalValue: PropTypes.string,
  reminderValue: PropTypes.string,
  saving: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onEdit: PropTypes.func,
  onReminderValueChange: PropTypes.func,
  onSave: PropTypes.func,
  onValueChange: PropTypes.func,
};

NoteEditor.defaultProps = {
  editButtonLabel: 'Edit',
  canEdit: true,
  edit: false,
  lines: 3,
  reminderLabel: '',
  saving: false,
};



// WEBPACK FOOTER //
// ./src/components/shared/NoteEditor.js